import api from '@/helpers/api'
import { createNamespacedHelpers } from 'vuex'
export const { mapState, mapMutations, mapActions } = createNamespacedHelpers('broadcast')

import Utils from "@/helpers/utils.js";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    broadcasts: [],
  },
  mutations: {
    setBroadcast: (state, data) => {}
  },
  actions: {
    getBroadcasts: async ({commit}) => {

    },
  }
}